import { Component, OnInit, Input, Output,  EventEmitter } from '@angular/core';
import { DataService } from 'src/app/data.service';
import { Router } from '@angular/router';
import { TextService } from 'src/app/services/text.service';
import { timer } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public user_login:string;
  public password_login:string;
  public login_act:string=localStorage.getItem('loggedIn');
  private fail_time:any;
  public oublier;
  public doubleAuth;

  //........
  // Double identification
  public doubleIdentification:string;
  public dbli_code_retour:string;
  public dbli_code_securite:string;
  public dbli_info_retour:string;
  public emailUtilisateur:string;
  //........

  // Chrono
  minutes: number = 10;
  secondes: number = 0;
  private intervalId: any;

  // ihm
  codeSecurite: string = '';
  msgcodeSecuriteIncorrecte = '';


  constructor(
    private data: DataService,
    private route:Router,
    public text:TextService
  ) { }

  ngOnInit() {


    // initialisation du Contexte / code de sécurité.
    // Information double identification
  
        
    this.dbli_code_retour="";
    this.dbli_code_securite="";
    this.dbli_info_retour="";

     this.login=0;
     if(this.login_act=='OK'){
       this.login=1;


        // Vérification plus tard
        const dateStockee = parseInt(localStorage.getItem("date") || '0', 10);
        const maintenant = new Date().getTime();

        // 48h en millisecondes = 48 * 60 * 60 * 1000
        const quaranteHuitHeures = 48 * 60 * 60 * 1000;

        if (maintenant - dateStockee > quaranteHuitHeures) {
          console.log("Plus de 48 heures se sont écoulées.");
          this.signOut();

        } else {
          console.log("Moins de 48 heures.");
          this.loginChange.emit(this.login);
        }

       
     }
else
{
  // initialisation du Contexte / code de sécurité.
  localStorage.setItem("email_utilisateur","");
  localStorage.setItem("mode_identification","");
}


     this.fail_time=localStorage.getItem("fail_time")?localStorage.getItem("fail_time"):0;
     this.oublier=0;
  }
  @Input() login;
  @Output() loginChange = new EventEmitter();
  func_login(){
    
    
    /*
    let tsql ="exec sp_festiming_login @compte_festime_login='{ihm_festime_login}', @compte_festime_password='{ihm_festime_password}'";
    tsql = tsql.replace("{ihm_festime_login}",this.user_login);
    tsql = tsql.replace("{ihm_festime_password}",this.password_login);
    //exec sp_festiming_login @compte_festime_login='mabouna2', @compte_festime_password='1234' 
    */

/*
 evolution double authentification , par code de sécurité

 OK	sp_festiming_login:OK;login / cle_axe_client / libelle_axe_client=mabouna2 / 13 / ABIOGES BAT C1	OK-LOGIN	mabouna2	MA ABOUNA	13	ABIOGES BAT C1	3.ADMIN		actif	marc.abouna@gmail.com	double

email_utilisateur : "marc.abouna@gmail.com" ou "" (vide)
mode_identification  : { "simple" , "double" }

https://devbackend.mytiming.fr/bkt.aspx?fonction=sendmail_verifcnx&param1=marc.abouna@gmail.com
Code de sécurité au système Mytiming : [ 773291 ]


*/


   let tsql ="exec sp_festiming_login @compte_festime_login='{ihm_festime_login}', @compte_festime_password='{ihm_festime_password}'";
   tsql = tsql.replace("{ihm_festime_login}",this.data.TransformParametreSpeciaux(this.user_login));
   tsql = tsql.replace("{ihm_festime_password}",this.data.TransformParametreSpeciaux(this.password_login));
   //alert(tsql);


    this.data.SqlSelectToJson(tsql).subscribe 
      (
        // OBSERVATEUR DEBUT .......................................................................................................
        // Evenement de Fin de d'exution correcte en provenance de l'observable
        (data:any) =>  {
         
          let mydata = data;



     if ( mydata[0].ReturnCode == 'OK' ) // Logged OK
     {
        localStorage.setItem('loggedIn','OK');
		    localStorage.setItem("login_utilisateur",mydata[0].login_utilisateur);
        localStorage.setItem("libelle_utilisateur",mydata[0].libelle_utilisateur);
        localStorage.setItem("cle_axe_client_rattachement",mydata[0].cle_axe_client_rattachement);
        localStorage.setItem("libelle_axe_client",mydata[0].libelle_axe_client);
        localStorage.setItem("code_profil",mydata[0].code_profil);
        localStorage.setItem("code_rh_groupe",mydata[0].code_rh_groupe);
        localStorage.setItem("actif_utilisateur",mydata[0].actif_utilisateur);
        
        // ..... Gestion ou pas de la double identification.
        localStorage.setItem("email_utilisateur",mydata[0].email_utilisateur);
        localStorage.setItem("mode_identification",mydata[0].mode_identification);
        // .....


        // Si identifié mode double
        if ( localStorage.getItem("mode_identification") == "double" )
        {
            this.doubleAuth = 1; // Afficher Ecran - code de sécurité
            this.oublier=1; // Effacer ecran login/password
            this.emailUtilisateur = localStorage.getItem("email_utilisateur");
            this.demarrerChrono();

            // envoyer le Mail et récupérer les informations pour faire la comparaison.
            // initialisation du Contexte
            this.dbli_code_retour="";
            this.dbli_code_securite="";
            this.dbli_info_retour="";
            this.GenCodeSecuriteViaEmail(this.emailUtilisateur);
            /*
            // patienter 5 secondes
            timer(5000).subscribe(() => {
              
              console.log('5 secondes se sont écoulées');


            });
           */


        }
        
        else 
        {
        //************
        // Le bloc à exécuter après la tentative de code de sécurité
        this.login=1;
        this.loginChange.emit(this.login); // aller au menu Mytiming
        localStorage.setItem("fail_time",'0');
        localStorage.setItem("date",new Date().getTime().toString());
        //************
        }


		  }
		  else // Logged KO
		  {
        // Logged KO
        localStorage.setItem('loggedIn','KO');
        localStorage.setItem("login_utilisateur", "");
        localStorage.setItem("libelle_utilisateur", "");
        localStorage.setItem("cle_axe_client_rattachement", "0");
        localStorage.setItem("libelle_axe_client", "");
        localStorage.setItem("code_profil","");
        localStorage.setItem("code_rh_groupe", "");
        localStorage.setItem("actif_utilisateur", "");

        // ..... Gestion ou pas de la double identification.
        localStorage.setItem("email_utilisateur","");
        localStorage.setItem("mode_identification","");
        // .....


        localStorage.setItem("fail_time",(parseInt(this.fail_time)+1).toString());
        this.fail_time=localStorage.getItem("fail_time");
        alert(this.fail_time+this.text.login.login_fail);
        return
		  }                                                                  
    },


    // Evenement d'erreur d'exécution en provenance de l'observable
    (error) =>       {                                       
           alert('error');          
		// Logged Error ( error logged on computer system )
		       localStorage.setItem('loggedIn','ERROR');
		       localStorage.setItem("login_utilisateur", "");
           localStorage.setItem("libelle_utilisateur", "");
        	 localStorage.setItem("cle_axe_client_rattachement", "0");
        	 localStorage.setItem("libelle_axe_client", "");
        	 localStorage.setItem("code_profil","");
        	 localStorage.setItem("code_rh_groupe", "");
           localStorage.setItem("actif_utilisateur", "");

            // ..... Gestion ou pas de la double identification.
            localStorage.setItem("email_utilisateur","");
            localStorage.setItem("mode_identification","");
            // .....

           },                          
          () =>         {} 
           // OBSERVATEUR FIN .......................................................................................................
            );
   }
 

   forget(){
     this.route.navigate(['/']);
     console.log('run');  
   }

   
   verifierCode()
   {
     if ( this.dbli_code_securite == this.codeSecurite )
     {
      //************
        // Le bloc à exécuter après la tentative de code de sécurité
        this.msgcodeSecuriteIncorrecte = '';
        this.login=1;
        this.loginChange.emit(this.login); // aller au menu Mytiming
        localStorage.setItem("fail_time",'0');
        localStorage.setItem("date",new Date().getTime().toString());
        //************
     }
     else
     {
      this.msgcodeSecuriteIncorrecte = "Code incorrecte. Si non réception du code, contacter l'administrateur Mytiming.";
     }
   }

   onClickGetCodeoOri() {
    let myemail = "marc.abouna@gmail.com";
  
    this.data.GetDoubleIdentification(myemail).subscribe(
      (response: any) => {
        console.log("Réponse du serveur :", response);
        // Tu peux aussi stocker le résultat dans une variable pour l'afficher dans le HTML
        this.doubleIdentification = response;
      },
      (error) => {
        console.error("Erreur HTTP :", error);
        this.doubleIdentification = "KO;-1;ERREUR_TECHNIQUE CALL HTTP";
      }
    );
  }
   



  onClickGetCode()
   {
    
    let the_email = localStorage.getItem("email_utilisateur").trim();
    
    if (the_email != "")
    {
    this.GenCodeSecuriteViaEmail( the_email );
    }
  }
  


  GenCodeSecuriteViaEmail(the_email:string)
  {
    let myemail = the_email;

    // initialisation du Contexte
    this.dbli_code_retour="";
    this.dbli_code_securite="";
    this.dbli_info_retour="";
  
    this.data.GetDoubleIdentification(myemail).subscribe(
      (response: string) => {
        console.log("Réponse du serveur :", response);
        this.doubleIdentification = response;
  
        // Découpage de la chaîne
        const parts = response.split(';');
  
        if (parts.length >= 3) {
          this.dbli_code_retour = parts[0];
          this.dbli_code_securite = parts[1].trim();
          this.dbli_info_retour = parts.slice(2).join(';'); // au cas où il y aurait des ';' dans le message
        } else {
          // Si la réponse est mal formée
          this.dbli_code_retour = "KO";
          this.dbli_code_securite = "";
          this.dbli_info_retour = "Réponse invalide";
        }
      },
      (error) => {
        console.error("Erreur HTTP :", error);
        this.doubleIdentification = "KO;-1;ERREUR_TECHNIQUE CALL HTTP";
  
        // Remplissage des champs avec des valeurs par défaut
        this.dbli_code_retour = "KO";
        this.dbli_code_securite = "-1";
        this.dbli_info_retour = "ERREUR_TECHNIQUE CALL HTTP";
      }
    );
        
  }



  signOut(){
    
    localStorage.removeItem('loggedIn');
    localStorage.removeItem("login_utilisateur");
    localStorage.removeItem("libelle_utilisateur");
    localStorage.removeItem("cle_axe_client_rattachement");
    localStorage.removeItem("libelle_axe_client");
    localStorage.removeItem("code_profil");
    localStorage.removeItem("code_rh_groupe");
    localStorage.removeItem("actif_utilisateur");

    // Information double identification
    localStorage.removeItem("email_utilisateur");
    localStorage.removeItem("mode_identification");



    this.login=0;
    this.loginChange.emit(this.login);
    window.location.reload();
}



  demarrerChrono() {
    this.intervalId = setInterval(() => {
      if (this.secondes === 0) {
        if (this.minutes === 0) {
          clearInterval(this.intervalId);
          
          // Gérer l'expiration ici si nécessaire
          // Simuler une Déonnexion.

            // Logged KO
            localStorage.setItem('loggedIn','KO');
            localStorage.setItem("login_utilisateur", "");
            localStorage.setItem("libelle_utilisateur", "");
            localStorage.setItem("cle_axe_client_rattachement", "0");
            localStorage.setItem("libelle_axe_client", "");
            localStorage.setItem("code_profil","");
            localStorage.setItem("code_rh_groupe", "");
            localStorage.setItem("actif_utilisateur", "");

            
            // ..... Gestion ou pas de la double identification.
            localStorage.setItem("email_utilisateur","");
            localStorage.setItem("mode_identification","");
            // .....
            

            localStorage.setItem("fail_time",(parseInt(this.fail_time)+1).toString());
            this.fail_time=localStorage.getItem("fail_time");


            this.signOut();


        } else {
          this.minutes--;
          this.secondes = 59;
        }
      } else {
        this.secondes--;
      }
    }, 1000);
  }



}
